import React from 'react';

const WeightIconOutlined: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 48 48" fill="none">
            <path
                d="M40.8048 17.0467C40.6195 15.18 39.0446 13.7333 37.1455 13.7333H33.7641V12.8933C33.7641 7.43333 29.7805 3 24.5926 3H24.4074C19.2195 3 15.2359 7.43333 15.2359 12.8933V13.7333H11.8545C9.95537 13.7333 8.42679 15.18 8.19519 17.0467L5.5086 42.9C5.46228 43.4133 5.60124 43.9733 5.9718 44.3467C6.34237 44.7667 6.85189 45 7.36142 45H41.6386C42.1481 45 42.6576 44.7667 43.0282 44.3933C43.3988 44.02 43.5377 43.46 43.4914 42.9467L40.8048 17.0467ZM18.9415 12.8933C18.9415 9.48667 21.3039 6.73333 24.4074 6.73333H24.5926C27.6961 6.73333 30.0585 9.48667 30.0585 12.8933V13.7333H18.9415V12.8933ZM9.39952 41.2667L11.8545 17.4667H37.0529L39.5078 41.2667H9.39952Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default WeightIconOutlined;
